/**
 * Chains the tasks in the order provided, where each task must return true to continue
 * @param tasks
 */
export const chainBooleanTasks = (
    ...tasks: Array<() => Promise<boolean>>
): Promise<boolean> => {
    if (tasks.length === 1) {
        return tasks[0]().then(succeeded => succeeded ? succeeded : Promise.reject(new Error('Task failed')));
    }

    return tasks.reduce(
        (chain, task) => {

            return (
                chain.then(succeeded => succeeded ? task() : Promise.reject(new Error('Task failed')))
            );
        },
        Promise.resolve(true)
    );
};



// WEBPACK FOOTER //
// ./src/utils/chain-boolean-tasks.ts